import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "../../Styles/ViewExamination.css";
import Loader from "../../Components/Loader";

function FacultyViewExamination() {
    const [exams, setExams] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchExams = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem("authToken");
                const response = await axios.get("https://api.uniums.com/api/exam/view-exams", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const examsWithCancelStatus = response.data.map((exam) => ({
                    ...exam,
                    isCanceled: !!exam.remark,
                }));

                setExams(examsWithCancelStatus);
            } catch (error) {
                console.error("Error fetching exams:", error);
                toast.error("Failed to fetch exams.");
            } finally {
                setLoading(false);
            }
        };

        fetchExams();
    }, []);

    return (
        <div className="view-examination-container">
            <ToastContainer />
            {loading && <Loader />}
            <h1>View Examinations</h1>

            <div className="exam-cards">
                {exams.map((exam) => (
                    <div
                        className={`exam-card ${exam.isCanceled ? "canceled-card" : ""}`}
                        key={exam._id}
                    >
                        <div className={`card-header ${exam.isCanceled ? "canceled-header" : ""}`}>
                            {exam.isCanceled && <p>Exam Canceled</p>}
                        </div>
                        <h2>Test Name: {exam.examName}</h2>
                        <p><strong>Date:</strong> {new Date(exam.examDate).toLocaleDateString()}</p>
                        <p>
                            <strong>Time: </strong>
                            {exam.examTime || "N/A"}
                        </p>
                        <p>
                            <strong>Time Duration: </strong>
                            {exam.examDuration || "N/A"}
                        </p>
                        <p><strong>Class:</strong> {exam.className}</p>
                        <p><strong>Subjects:</strong></p>
                        <ul>
                            {exam.subjects.map((subject) => (
                                <li key={subject.subject}>
                                    {subject.subject} - {subject.questionType} ({subject.totalMarks} marks)
                                </li>
                            ))}
                        </ul>
                        <p><strong>Details:</strong> {exam.examDetails ? exam.examDetails : "No details available"} </p>
                        {exam.isCanceled && <p className="remark_color"><strong>Remark:</strong> {exam.remark}</p>}
                        <p className="download_btn_p">
                            {exam.documentDetails ? (
                                <a href={exam.documentDetails} download>Download File </a>
                            ) : (
                                "Document Not Available"
                            )}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FacultyViewExamination;
